import { useRef, useEffect } from 'react';

export const useNonInitialEffect = (
  effect: () => void,
  dependencies: React.DependencyList
) => {
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
